import axios from "axios";
import React from "react";
import Header from "../../header";
import { apiCall_domain, token } from "../../api";
import Select from "react-select";
import PulseLoader from "react-spinners/PulseLoader";
import SimpleReactValidator from "simple-react-validator";
class UserInfo extends React.Component {
  state = {
    cityList: [],
    city_id: null,
    countryStatesId: null,
    value: "",
    selectedCity: "انتخاب شهر",
    selectedState: "انتخاب استان",
    loading: false,
    countryStates: [],
    name: "",
    familyName: "",
    password: "",
    rePassword: "",
    referralCode: "",
  };

  constructor() {
    super();
    this.validator = new SimpleReactValidator({
      className: "danger error",
      messages: {
        required: "این فیلد نباید خالی باشد",
        min: "رمز عبور نمی تواند کمتر از 8 کاراکتر باشد",
        max: "رمز عبور نمی تواند بیشتر از 16 کاراکتر باشد",
      },
      validators: {
        sameAsConfirmPass: {
          message: "رمز عبور با تکرار آن برابر نیست",
          rule: () => {
            if (this.state.password != this.state.rePassword) {
              return false;
            }
            return true;
          },
        },
      },
      autoForceUpdate: this,
    });
  }

  componentDidMount() {
    const Headers = {
      Authorization: token(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/cities`, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({ countryStates: res.data });
      });
    axios
      .get(`${apiCall_domain}/customer/user`, { headers: Headers })
      .then((res) =>
        this.setState({
          userInfo: res.data,
          selectedCity: res.data.city.name,
          selectedState: res.data.province.name,
        }),
      );
  }
  handleLoader = () => {
    this.setState({ loading: !this.state.loading });
  };
  changeField = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };
  SignUp = () => {
    this.validator.showMessages();
    // if all fields were valid and there wasnt any pending request submit the form
    if (this.validator.allValid() && this.state.loading === false) {
      this.handleLoader();
      const headers = {
        Authorization: token(),
        "content-type": "application/json",
      };
      const user = {
        phone: localStorage.getItem("phone"),
        name: `${this.state.name} ${this.state.familyName}`,
        city_id: this.state.city_id,
        password: this.state.password,
        activation_code: localStorage.getItem("validationCode"),
        dev_type: "PWA",
        gcm_id: 1,
        reagent_id: this.state.referralCode,
        // major_info: null,
      };

      axios
        .post(`${apiCall_domain}/customer/auth/register`, user, { headers })
        .then((res) => {
          this.handleLoader();
          localStorage.setItem("Api_key", res.data.api_key);
          const url = new URL(window.location.href);
          window.location.replace(url.origin);
        });
    }
  };
  render() {
    const stateHandleChange = (selectedState) => {
      this.setState({
        selectedState,
        countryState: selectedState.city_id,
      });
      this.setState({ cityList: selectedState.cities });
    };

    const handleChange = (selectedCity) => {
      this.setState({ selectedCity, city_id: selectedCity.city_id });
    };

    return (
      <>
        <Header showSearchBar={true} title={"تکمیل اطلاعات"} />
        <div className="infoSignUp">
          <div className="boxInfo">
            <div className="warning">
              <img src="/public/assets/icons/Warning.svg" alt="عکس"></img>
              <span>در صورت مغایرت سفارشات با مشکل مواجه میشود</span>
            </div>
            <div className="forms">
              <input
                className="field"
                placeholder="نام"
                type="text"
                name="name"
                onChange={this.changeField}
              />
              {this.validator.message("name", this.state.name, "required")}

              <input
                placeholder="نام خانوادگی"
                className="field"
                type="text"
                name="familyName"
                onChange={this.changeField}
              />
              {this.validator.message(
                "familyName",
                this.state.familyName,
                "required",
              )}
              <Select
                className="cities"
                name="states"
                value={this.state.selectedState}
                onChange={stateHandleChange}
                options={this.state.countryStates.map((item) => ({
                  city_id: item.id,
                  value: item.name,
                  label: item.name,
                  cities: item.cities,
                }))}
                placeholder={this.state.selectedState}
              />
              {this.validator.message(
                "states",
                this.state.countryState,
                "required",
              )}
              <Select
                className="cities"
                name="city"
                value={this.state.selectedCity}
                onChange={handleChange}
                options={this.state.cityList.map((item) => ({
                  city_id: item.id,
                  value: item.name,
                  label: item.name,
                }))}
                placeholder={this.state.selectedCity}
              />
              {this.validator.message("city", this.state.city_id, "required")}

              <input
                type="password"
                className="field"
                name="password"
                placeholder="رمزعبور"
                onChange={this.changeField}
              />
              {this.validator.message(
                "password",
                this.state.password,
                "required|min:8|max:16",
              )}

              <input
                type="password"
                className="field"
                name="rePassword"
                placeholder="تکرار رمزعبور"
                onChange={this.changeField}
              />
              {this.validator.message(
                "rePassword",
                this.state.rePassword,
                "required|min:8|max:16|sameAsConfirmPass",
              )}

              <input
                type="text"
                className="field"
                name="referralCode"
                placeholder="کد معرف (اختیاری) "
                onChange={this.changeField}
              />
            </div>
          </div>
          <div className="mySecContinue mySecContinueInfoBtn">
            {this.state.loading ? (
              <button className="btn disabled">
                <PulseLoader size={12} color="#fff" loading={true} />
              </button>
            ) : (
              <button onClick={this.SignUp}>تایید</button>
            )}
          </div>
        </div>
      </>
    );
  }
}
export default UserInfo;
